<template>
  <!-- iOS app: nothing in the drawer — it closes and the charge opens in the in-app browser (see onMounted) -->
  <div v-if="asPage" class="flex-1 flex items-center justify-center py-8">
    <i class="pi pi-spin pi-spinner text-2xl text-surface-400" />
  </div>
  <PaymePaymentForm
    v-else
    v-bind="$attrs"
    :paymentUuid="paymentUuid"
    :maxInstallments="12"
    :showWallet="false"
    @completed="emit('completed')" />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { Capacitor } from '@capacitor/core';
import { useToast } from 'vue-toastification';
import { PaymePaymentForm, useDrawer } from '@torim-app/shared-components';
import { openManualChargeInBrowser } from '@app/utils/manual-charge-browser';

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  paymentUuid: string;
}>();

const emit = defineEmits<{
  (e: 'completed'): void;
}>();

// In the iOS app PayMe's card fields (iframes) take no touches inside the app's web view —
// not in the drawer and not on a page of their own either. So on iOS the charge runs in the
// in-app browser (Safari), where they work. The sheet may be stacked on the appointment's
// drawer, hence closing twice.
const asPage = Capacitor.getPlatform() === 'ios';
const { closeDrawer } = useDrawer();
const toast = useToast();

onMounted(async () => {
  if (!asPage) return;
  closeDrawer();
  closeDrawer();
  try {
    await openManualChargeInBrowser(props.paymentUuid);
  } catch (e) {
    console.error('[manual-charge] failed to open browser', e);
    toast.error('לא הצלחנו לפתוח את טופס החיוב');
  }
});
</script>
